import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';

import { LANGUAGE_KEYS } from 'src/constants';
import { LanguageTitle } from './styled';

export const LanguageDropdown = memo(function LanguageDropdown() {
  const [t, i18n] = useTranslation(['common']);

  const onChangeLanguage = useCallbackRef((key: string) => i18n.changeLanguage(key));

  return (
    <DropdownList
      minWidth={false}
      buttonComponent={
        <Button iconOnly ghost data-testid='language-button' title={t('common:LANGUAGE')}>
          <Icons.Globe size={20} />
        </Button>
      }>
      {LANGUAGE_KEYS.map((language) => (
        <DropdownList.DropdownItem
          key={language}
          onClick={() => onChangeLanguage(language)}
          dataTestId={`language-list-item-${language}`}
          isSelected={language === i18n.language}>
          <LanguageTitle>{language}</LanguageTitle>
        </DropdownList.DropdownItem>
      ))}
    </DropdownList>
  );
});
